<template>
	<div class="dashboard">
		<div class="dashboard__grid dashboard__grid--five-cards">
			<!-- Portfolio Benchmark Widget -->
			<div class="dashboard__widget">
				<div class="dashboard__card">
					<portfolio-benchmark-widget
						:benchmark="portfolioBenchmark"
					/>
				</div>
			</div>

			<!-- Leases Due Widget -->
			<div class="dashboard__widget">
				<div class="dashboard__card">
					<leases-due-widget
						:site-data="sites"
						@leases-due-tooltip="handleLeasesDueTooltip"
						@years-changed="handleYearsChanged"
					/>
				</div>
			</div>

			<!-- Leases Due Utilization Card (NEW) -->
			<div class="dashboard__widget">
				<div class="dashboard__card">
					<leases-due-utilization-card
						:site-data="sites"
						:selected-years="selectedYears"
					/>
				</div>
			</div>


			<!-- Active Projects Widget -->
			<div class="dashboard__widget">
				<div class="dashboard__card">
					<active-projects-widget
						v-show="!leasesDueTooltipVisible"
						:chart-data="activeProjectsChartData"
						@visibility-change="handleActiveProjectsTooltip"
					/>
				</div>
			</div>

			<!-- Properties by Broker Widget -->
			<div class="dashboard__widget">
				<div class="dashboard__card">
					<properties-by-broker-widget />
				</div>
			</div>
		</div>

		<div class="dashboard__table-section">
			<properties-table
				:projects="projects"
				:sites="sites"
			/>
		</div>
	</div>
</template>

<script>
import PortfolioBenchmarkWidget from './PortfolioBenchmarkWidget.vue';
import LeasesDueWidget from './LeasesDueWidget.vue';
import LeasesDueUtilizationCard from './LeasesDueUtilizationCard.vue';
import ActiveProjectsWidget from './ActiveProjectsWidget.vue';
import PropertiesByBrokerWidget from './PropertiesByBrokerWidget.vue';
import PropertiesTable from './PropertiesTable.vue';

export default {
	name: 'DashboardV1',
	components: {
		PortfolioBenchmarkWidget,
		LeasesDueWidget,
		LeasesDueUtilizationCard,
		ActiveProjectsWidget,
		PropertiesByBrokerWidget,
		PropertiesTable
	},
	props: ['projects', 'activeProjectsChartData', 'sites', 'portfolioBenchmark'],
	data() {
		return {
			leasesDueTooltipVisible: false,
			activeProjectsTooltipVisible: false,
			selectedYears: 3
		}
	},
	methods: {
		handleLeasesDueTooltip(visible) {
			this.leasesDueTooltipVisible = visible;
		},
		handleActiveProjectsTooltip(visible) {
			this.activeProjectsTooltipVisible = visible;
		},
		handleYearsChanged(years) {
			this.selectedYears = years;
		}
	}
}
</script>
